import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>TECHNICAL SKILLS</h5>
      <h2>MY EXPERIENCE</h2>

      <div className="container experience__container">
        <div className="experience__forntend">
          <h3>FRONTEND DEVELOPMENT</h3>
          <div className="experience__content">
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>HTML</h4>
            <small className='text-light'>EXPERIENCE</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>CSS</h4>
            <small className='text-light'>EXPERIENCE</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>JAVASCRIPT</h4>
            <small className='text-light'>EXPERIENCE</small>
            </div>
            </article>
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Tailwind CSS</h4>
            <small className='text-light'>Experience</small>
            </div>
            </article> */}
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>REACT</h4>
            <small className='text-light'>EXPERIENCE</small>
            </div>
            </article>
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>React Native</h4>
            <small className='text-light'>Intermediate</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Next JS</h4>
            <small className='text-light'>Intermediate</small>
            </div>
            </article> */}
            </div>
        </div>
{/* ==================== END OF FRONTEND ============================ */}
        <div className="experience__backend">
        <h3>BACKEND DEVELOPEMENT</h3>
          <div className="experience__content">
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>PHP</h4>
            <small className='text-light'>Experience</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>MongoDB</h4>
            <small className='text-light'>Intermediate</small>
            </div>
            </article> */}
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>MySQL</h4>
            <small className='text-light'>INTERMEDIATE</small>
            </div>
            </article>
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Python Flask</h4>
            <small className='text-light'>Intermediate</small>
            </div>
            </article> */}
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Express</h4>
            <small className='text-light'>Intermediate</small>
            </div>
            </article> */}
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>NODE JS</h4>
            <small className='text-light'>INTERMEDIATE</small>
            </div>
            </article>
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Neo4j</h4>
            <small className='text-light'>Begginer</small>
            </div>
            </article> */}
        </div>
        </div>
{/* ==================== END OF BACKEND ============================ */}

        <div className="experience__Technologies">
          <h3>TECHNOLOGIES</h3>
          <div className="experience__content">
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>GIT & GITHUB</h4>
            <small className='text-light'>EXPERIENCE</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>DOCKER</h4>
            <small className='text-light'>BEGGINER</small>
            </div>
            </article>
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Selenium</h4>
            <small className='text-light'>Intermediate</small>
            </div>
            </article> */}
            
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Linux</h4>
            <small className='text-light'>Experience</small>
            </div>
            </article> */}
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Machine Learning</h4>
            <small className='text-light'>Intermediate</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Android Studios</h4>
            <small className='text-light'>Intermediate</small>
            </div>
            </article> */}
          </div>
        </div>
{/* ==================== END OF Technologies ============================ */}
        
<div className="experience__Lnaguages">
          <h3>LANGUAGES</h3>
          <div className="experience__content">
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>C PROGRAMMING</h4>
            <small className='text-light'>INTERMEDIATE</small>
            </div>
            </article>
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>JAVA</h4>
            <small className='text-light'>Experience</small>
            </div>
            </article> */}
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>PYTHON PROGRAMMING</h4>
            <small className='text-light'>INTERMEDIATE</small>
            </div>
            </article>
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Type Script</h4>
            <small className='text-light'>Begginer</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Rust</h4>
            <small className='text-light'>Begginer</small>
            </div>
            </article> */}
            {/* <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Kali</h4>
            <small className='text-light'>Intermediate</small>
            </div>
            </article> */}
          </div>
        </div>

       
      </div>
    </section>
  )
}

export default Experience